import { createToaster } from "@ark-ui/solid";
import type { JSXElement } from "solid-js";

export enum ToastMessageTypes {
	Default = "default",
	Error = "error",
	Warning = "warning",
	Success = "success",
	Info = "info"
}

export type ToastMessage = {
	title?: string;
	description?: string;
	type?: ToastMessageTypes;
	children?: JSXElement;
	timeout?: number;
	containerClass?: string;
};

export type ToastMeta = {
	RenderAs?: JSXElement;
};

export const toaster = createToaster({
	placement: "bottom",
	overlap: true,
	gap: 12
});

export const showToastMessage = (msg: ToastMessage) => {
	const duration = msg.timeout || 3000;

	const type = msg.type || ToastMessageTypes.Default;

	const toastId = `toast-${Date.now()}`;
	const meta: ToastMeta = {
		RenderAs: msg.children
	};
	toaster.create({
		id: toastId,
		title: msg.title,
		description: msg.description,
		duration,
		type: type,
		meta
	});
};
